import { createContext, useContext } from "react";
import { useRouter } from "next/router";
import { useAuthState } from "react-firebase-hooks/auth";

import { auth } from "../lib/firebase";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const router = useRouter();
  const [user, loading] = useAuthState(auth);

  if (loading) return null;

  if (!user && router.pathname !== "/login") {
    router.push("/login");
    return null;
  }

  if (user && router.pathname === "/login") {
    router.push("/");
    return null;
  }

  return (
    <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
